<template>
  <img
    v-bind="$attrs"
    :src="source"
    :alt="alt"
    @error="useFallback = true"
  >
</template>

<script>
import { organizationBranding } from '@/services/organizationBranding'

export default {
  name: 'OrganizationLogo',
  inheritAttrs: false,
  props: {
    alt: {
      type: String,
      default: 'Organization logo'
    },
    fallbackSrc: {
      type: String,
      default: '/logo.png'
    }
  },
  data () {
    return {
      useFallback: false,
      branding: organizationBranding
    }
  },
  computed: {
    source () {
      return this.useFallback || !this.branding.logoUrl
        ? this.fallbackSrc
        : this.branding.logoUrl
    }
  },
  watch: {
    'branding.logoUrl' () {
      this.useFallback = false
    }
  }
}
</script>
